import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconNoteText: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"note-text"} maskId="square-filled-radius-0-stroke-1-IconNoteText"><path fillRule="evenodd" clipRule="evenodd" d="M3 21V3H21V15H15V21H3ZM8 8H16V9H8V8ZM8 12V13H12V12H8Z" fill="currentColor"/><path d="M16 21H16.2071L21 16.2071V16H16V21Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconNoteText;
